import { get, post } from "@/shared/utils/fetchApi";
import { API_CONFIG } from "@/infrastructure/config/api";
import type { BackgroundTask, ChatActivity } from "../types/backgroundTasks";

/** As tarefas em segundo plano de uma conversa do Playground (AB#86889). */
export class BackgroundTasksService {
  /** GET /chats/:chatId/background-tasks — as vivas e as recém-encerradas, mais novas primeiro. */
  static async list(chatId: string): Promise<BackgroundTask[]> {
    const result = await get<{ data: BackgroundTask[] }>(`/chats/${chatId}/background-tasks`);
    return result?.data ?? [];
  }

  /**
   * GET /chats/activity — as conversas do workspace com algo acontecendo: o agente respondendo ou
   * tarefa em segundo plano. É a bolinha do Chat no menu lateral, fora do Playground.
   */
  static async activity(productId: string): Promise<ChatActivity[]> {
    const result = await get<{ data: ChatActivity[] }>(`/chats/activity?product_id=${encodeURIComponent(productId)}`);
    return result?.data ?? [];
  }

  /** POST /chats/:chatId/background-tasks/:taskId/cancel — a tarefa para de ser acompanhada. */
  static async cancel(chatId: string, taskId: string): Promise<BackgroundTask> {
    const result = await post<{ data: BackgroundTask }>(`/chats/${chatId}/background-tasks/${taskId}/cancel`, {});
    return result.data;
  }

  /** A sala SSE do usuário: tarefas que mudam e respostas que chegam noutra conversa. */
  static streamUrl(): string {
    return `${API_CONFIG.API_ROOT_URL}/background-tasks/stream`;
  }
}
